import { makeStyles } from "@material-ui/core/styles";

export const seatCountInfoCardStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 350,
    minWidth: 250,
    marginBottom: 20,
    marginRight: 10,
  },
  contentWrapper: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 0,
  },
  count: {
    fontSize: 52,
    fontWeight: "bold",
    marginBottom: 0,
  },
  link: {
    fontSize: 14,
    "&:hover": {
      color: "#3E7EF8",
    },
  },
  progressBar: {
    width: "50%",
    marginBottom: 10,
    marginTop: 10,
  },
}));
